<template>
  <a href="javascript:;" class="kp-select-open" @click="boxSetActive(box);modalOpen('delete-box')">
    <i class="icon-kp-delete"></i>{{ $t('general.actions.delete') }}
  </a>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: [
    'box',
  ],
  methods: mapActions([
    'modalOpen',
    'boxSetActive',
  ]),
};
</script>



/** WEBPACK FOOTER **
 ** ButtonDelete.vue?2aecca38
 **/